<template>
  <div class="siteWrap">
    <Header></Header>
    <div class="orderWrap">
      <img class="banner" src="~@/assets/images/u693.png" alt="">
      <div class="crumbs">
        <template v-if="model == 'ticket'">
          <span>景点门票</span><span>/</span><span class="activeCrumbs">门票预订</span>
        </template>
        <template v-if="model == 'package'">
          <span>度假套餐</span><span>/</span><span class="activeCrumbs">套餐预订</span>
        </template>
        <template v-if="model == 'hotel'">
          <span>度假酒店</span><span>/</span><span class="activeCrumbs">酒店预订</span>
        </template>
        <template v-if="model == 'store'">
          <span>风物文创</span><span>/</span><span class="activeCrumbs">在线预定</span>
        </template>
      </div>
      <div class="stepTab">
        <span :class="['stepTabItem', { 'active': path_name == 'orderAdd' }]">
          <i class="completeIcon el-icon-check" v-if="['orderAdd', 'orderPay', 'orderSuccess'].includes(path_name)"></i>
          填写订单
        </span>
        <img src="~@/assets/images/u1154.svg" alt="" />
        <span :class="['stepTabItem', { 'active': path_name == 'orderPay' }]">
          <i class="completeIcon el-icon-check" v-if="['orderPay', 'orderSuccess'].includes(path_name)"></i>
          支付
        </span>
        <img src="~@/assets/images/u1154.svg" alt="" />
        <span :class="['stepTabItem', { 'active': path_name == 'orderSuccess' }]">
          <i class="completeIcon el-icon-check" v-if="['orderSuccess'].includes(path_name)"></i>
          预订成功
        </span>
      </div>
      <router-view />
      <!-- 服务保障 -->
      <Service></Service>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Header from "@/components/header";
import Footer from "@/components/footer"
import Service from "@/components/service"
export default {
  name: 'Layout',
  components: {
    Header,
    Footer,
    Service
  },
  computed: {
    ...mapGetters(["path_name", "model"])
  },
  data() {
    return {

    }
  },
  created() {

  }
}
</script>
<style lang='scss' scoped>
.orderWrap {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;

  .banner {
    width: 100%;
    aspect-ratio: 1920/380;
    object-fit: none;
    object-position: center 25%;
    background-color: #4f99a5;
  }

  .stepTab {
    width: 75.7%;
    min-width: 1200px;
    display: grid;
    grid-template-columns: 417fr 94.5fr 417fr 94.5fr 417fr;
    align-items: center;
    margin: 15px 0;

    .active {
      border-bottom: 2px solid rgba(95, 169, 180, 0.972549019607843);
    }

    span {
      width: 100%;
      font-weight: 400;
      font-style: normal;
      font-size: 18px;
      color: rgba(95, 169, 180, 0.972549019607843);
      text-align: center;
      padding: 13px 0;
      box-sizing: border-box;
    }

    img {
      width: 10px;
      margin: 0 auto;
    }

    .stepTabItem {
      display: flex;
      align-items: center;
      justify-content: center;
      column-gap: 10px;
    }

    .completeIcon {
      width: 40px;
      height: 40px;
      color: #ffffff;
      font-weight: bold;
      border-radius: 50%;
      background-color: #4f99a5;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>